import "./App.css";
import { useContext, useEffect, Suspense, lazy } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import {
  // TrangChu,
  // Login,
  Register,
  AutoLoginSteam,
  ChiTiet,
  XemGame,
  KhamPha,
  QuanLyThue,
  AccountPage,
  PaymentPage,
} from "./pages";
const Login = lazy(() => import("./pages/Login"));
const TrangChu = lazy(() => import("./pages/home"));
const Verify = lazy(() => import("./pages/Verify"));
const VerifyApp = lazy(() => import("./pages/VerifyApp"));
const LandingPage = lazy(() => import("./pages/LandingPage"));
// const SuccessPage = React.lazy(() => import("./pages/SuccessPage"));
import Layout from "./components/Layout/Layout";
// import Verify from "./pages/Verify";
// import VerifyApp from "./pages/VerifyApp";
import { socket } from "./helpers/socket.helper";
import Swal from "sweetalert2";
import { getRockstarOTP } from "./apis/game/game";
import { isArray, isEmpty } from "lodash";
import SuccessPage from "./pages/SuccessPage";
import { StateContext } from "./context/reducer";
import { electronConstants } from "./constant";
import { message } from "antd";

const isElectron = () => Boolean(window.electron);

export default function App() {
  const { state } = useContext(StateContext);
  const { user } = state;

  // Web browser: landing intro + tải app (không redirect Facebook)
  // Electron: full app như cũ

  useEffect(() => {
    if (user && user.timesLeft) {
      const timerId = setTimeout(() => {
        if (user.rentStatus && window.electron?.sendToMain) {
          window.electron.sendToMain(electronConstants.LOG_OUT_STEAM);
        }
      }, user.timesLeft * 1000);

      return () => {
        clearTimeout(timerId);
      };
    }
  }, [user]);

  useEffect(() => {
    if (!isElectron()) return;

    socket.on("login_status", async (res) => {
      if (!res.isLogin) {
        const result = await Swal.fire({
          title: "Đăng nhập không thành công?",
          text: res.message,
          icon: "error",
          confirmButtonText: "Xác Nhận",
        });
        if (result.isConfirmed) {
          localStorage.removeItem("accessToken");
          window.location.reload();
        } else {
          setTimeout(() => {
            localStorage.removeItem("accessToken");
            window.location.reload();
          }, 5000);
        }
      }
    });
  }, [socket]);

  useEffect(() => {
    if (window?.electron?.receiveFromMain) {
      window.electron.receiveFromMain("sendOTPfromEmail", async (data) => {
        let retry = 0;
        let success = false;

        const fetchOTP = async () => {
          try {
            const res = await getRockstarOTP(data?.email);
            if (!isEmpty(res.data)) {
              console.log(
                "show data",
                isArray(res.data) ? res.data[res.data.length - 1] : res.data
              );
              window.electron.sendToMain(
                "getOTPfromemail",
                isArray(res.data) ? res.data[res.data.length - 1] : res.data
              );
              success = true;
            } else {
              retry++;
              setTimeout(fetchOTP, 1000);
            }
          } catch (err) {
            retry++;
            console.log(
              `Lỗi khi lấy OTP từ hệ thống. Lần thử thứ ${retry}`,
              err
            );
            if (retry < 5 && !success) {
              setTimeout(fetchOTP, 1000);
            } else if (retry === 5) {
              message.error(err.message);
            }
          }
        };

        if (data?.email) {
          fetchOTP();
        }
      });
    }
  }, []);

  if (!isElectron()) {
    return (
      <Suspense fallback={"Cyberking Teemo..."}>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<LandingPage />} />
          </Routes>
        </BrowserRouter>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={"Free Game App..."}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<TrangChu />} />
            <Route path="/steam" element={<AutoLoginSteam />} />
            <Route path="/chitiet" element={<ChiTiet />} />
            <Route path="/xemgame/:id" element={<XemGame />} />
            <Route path="/khampha" element={<KhamPha />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/quanlythue" element={<QuanLyThue />} />
            <Route path="/account/:tab" element={<AccountPage />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify/:email" element={<Verify />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/forgot-password" element={<VerifyApp />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}
